const palfeLocalConfig:any = {
  // API_HOST: 'http://localhost:3001',
  // SUPPORT_EMAIL: 'sample@example.com',
  GOOGLE_AD_SLOT: '6298209374',
}

export default palfeLocalConfig
